import React, {PureComponent} from "react"
import {match as Match} from "react-router-dom"

import {IndexRedirect, NestedRoute} from "@irati/utils/history/routing"

import ViewTeams from "../containers/Teams/ViewTeams"
import CreateTeam from "../components/Teams/CreateTeam/CreateTeam"
import AssignToTeam from "../containers/Users/AssignUsersToTeam"

interface Props {
  match: Match
}

class TeamSettings extends PureComponent<Props> {
  render() {
    const {match} = this.props
    return (
      <>
        <IndexRedirect match={match} to="/view" />
        <NestedRoute component={ViewTeams} exact match={match.url} path="/view" title="View Teams" />
        <NestedRoute
          component={CreateTeam}
          componentProps={{
            useModal: false
          }}
          exact
          match={match.url}
          path="/add"
          title="Create Team"
        />
        <NestedRoute component={AssignToTeam} exact match={match.url} path="/assignManagers" title="Add multiple people" />
        <NestedRoute component={AssignToTeam} exact match={match.url} path="/assignMembers/:uuid" title="Add multiple people" />
      </>
    )
  }
}

export default TeamSettings
